import React, { ReactElement } from "react";
import ProductsList from "../../components/products";
import Layout from '../../components/layout';

const ProductsPage = (): ReactElement => {
  return (
    <Layout>
      <ProductsList />
    </Layout>
  );
};

export default ProductsPage;
